
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"25","fill":"none","viewBox":"0 0 24 25"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","d":"M17.017 1.71H6.982c-.665 0-1.303.268-1.774.744a2.554 2.554 0 0 0-.734 1.795V23.71L12 16.941l7.526 6.77V4.248a2.55 2.55 0 0 0-.735-1.795 2.494 2.494 0 0 0-1.774-.744Z"}}),_c('clipPath',{attrs:{"id":"icon-bookmark-outline__a"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z","transform":"translate(0 .71)"}})])])
          )
        }
      }
    